export default {
	terms: "Termini e Condizioni",
	and: "E",
	actions: {
		Submit: "Invia",
		BackToLogin: "Torna al login",
		Register: "Registrati",
		Logout: "Esci",
		Update: "Aggiorna",
		Verify: "Verifica",
		connect: "Connetti",
		Taptochange: "Tocca per cambiare"
	},
	rules: {
		isRequired: "Obbligatorio",
		require: "{0} è obbligatorio",
		valid: "{0} non è un {0} valido",
		cannotContainBlankStrings: "{0} non può contenere stringhe vuote"
	},
	options: {
		gender: ["Maschio", "Femmina"]
	}
};
